import { useReviewContext } from "@hooks/useReviewSnippet";
import { type ComponentProps } from "@ts/components";
import React, { useEffect, type FC } from "react";

type ReviewsInlineInputProps = ComponentProps & {
  productGroup: string;
};

type ReviewsInlineOutputProps = ReviewsInlineInputProps;

export const withReviewsInline =
  (Component: FC<ReviewsInlineOutputProps>) =>
  ({
    name = "ReviewsInline",
    productGroup,
    className,
  }: ReviewsInlineInputProps) => {
    const { addProductToQueue } = useReviewContext();

    useEffect(() => {
      if (!productGroup || !addProductToQueue) {
        return;
      }

      addProductToQueue(productGroup);
    }, [productGroup]);

    Component.displayName = name;
    return <Component productGroup={productGroup} className={className} />;
  };
